import React from 'react';
import Link from 'next/link';
import DropDown from './Dropdown';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';

function Navbar(props) {
    return (
        <div className="navbar group inline-block">
            <Link color="inherit" href="/" passHref>
                <a>
                    <HomeRoundedIcon style={{ color: '#b9b9b9', cursor: 'pointer' }} />
                </a>
            </Link>
            <Link color="inherit" href="/home" passHref>
                <div className="group inline-block navbar">
                    <div className="outline-none focus:outline-none px-3 py-1 bg-white rounded-sm flex items-center min-w-32">
                        <span className="pr-1 font-semibold flex-1 menuname">Нүүр</span>
                    </div>
                </div>
            </Link>
            {props.menus.length > 0 &&
                props.menus.map((item) => {
                    return <DropDown key={item.id} menu={item} />;
                })}
        </div>
    );
}

export default Navbar;
